// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 3874 ? "1a48c3c1" : chunkId) + "." + {"1330":"4320d6348dd5918b","3874":"29b56595eae3de5e","4816":"27554f4d7faaeeab","5367":"f935494f210d4f5e"}[chunkId] + ".js";
};